export const SITE = {
  name: "Grupo Augustinis",
  legal: "Grupo Augustinis Direito e Soluções LTDA",
  tagline: "Estratégia Jurídica. Soluções Reais. Resultados que transformam.",
  whatsappDisplay: "+55 21 98038-9909",
  whatsappNumber: "5521980389909",
  instagram: "@grupoaugustinis",
  instagramUrl: "https://instagram.com/grupoaugustinis",
  city: "Rio de Janeiro — RJ",
};

export const waLink = (text = "Olá! Vim pelo site do Grupo Augustinis e gostaria de uma análise do meu caso.") =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;
